import React, { useEffect, useMemo } from 'react'
import { Alert, Checkbox, Skeleton, Space } from 'antd'
import useQueryParam from '../../../../../../hooks/useQueryParam'
import { ASSIGNEE_IDS_PARAM } from '../../../../../../constants/query-params'
import useQueryParamSetter from '../../../../../../hooks/useQueryParamSetter'
import { useFetchAssignmentSharedWithQuery } from '../../../../../../store/apis/shared-assignment.api'
import { fetchAssignmentSharedWithSelectors } from '../../../../../../store/apis/utils/selectors/shared-assignment.api.selectors'
import { useParams } from 'react-router'
import User from '../../../../../../components/common/user/User'
import { useSelector } from 'react-redux'
import userSelectors from '../../../../../../store/selectors/user.selectors'
import assignmentSelectors from '../../../../../../store/selectors/assignment.selectors'

const AssigneeFilters = () => {
    const queryParam = useQueryParam(ASSIGNEE_IDS_PARAM)
    const setQueryParam = useQueryParamSetter()
    const userId = useSelector(userSelectors.id)
    const isAssignmentOwner = useSelector(assignmentSelectors.isOwner)
    const assignmentOwnerId = useSelector(assignmentSelectors.ownerId)
    const assignmentOwnerName = useSelector(assignmentSelectors.ownerName)
    const currentUser = useSelector(userSelectors.user)

    const { token } = useParams()

    let userIds = queryParam ? queryParam.split(',').map(Number) : []

    const {
        data: users,
        isFetching,
        error,
    } = useFetchAssignmentSharedWithQuery(
        { token },
        {
            selectFromResult: result => fetchAssignmentSharedWithSelectors.selectOnlyUsers(result),
        },
    )

    const allUsers = useMemo(
        () =>
            users
                ? [
                      {
                          id: assignmentOwnerId,
                          name: assignmentOwnerName,
                      },
                      ...users,
                  ].map(user => ({
                      id: user.id,
                      name: user.id === currentUser.id ? `${user.name} (You)` : user.name,
                  }))
                : undefined,
        [users, currentUser, assignmentOwnerId, assignmentOwnerName],
    )

    useEffect(() => {
        if (userIds.length === 0 && !isAssignmentOwner) {
            setQueryParam({ [ASSIGNEE_IDS_PARAM]: userId })
        }
    }, [])

    const options = allUsers?.map(user => (
        <Checkbox key={user.id} value={user.id}>
            <User size='small' name={user.name} id={user.id} />
        </Checkbox>
    ))

    const handleChange = checkedValues => {
        setQueryParam({ [ASSIGNEE_IDS_PARAM]: checkedValues.join(',') })
    }

    if (isFetching) return <Skeleton />
    if (error) return <Alert description='An error occurred while fetching users' type='error' />
    return (
        <Checkbox.Group onChange={handleChange} value={userIds}>
            <Space direction='vertical'>{options}</Space>
        </Checkbox.Group>
    )
}

export default AssigneeFilters
